<template lang="pug">
extends ../Base/Card.pug

block card-header
    div.card-header-title
        h2.title(v-if="title") {{ title }}
        div.curator(v-if="curatorName") {{ curatorName }}

    //- social block inside the header
    social-follow(v-if="social && item"
        resource="collections"
        v-bind:item="item")


block card-contents
    slot


</template>

<script>
import BaseCard from '@/components/Base/Card';

export default {
    name: 'collection-card',

    extends: BaseCard,

    props: {
        className: {         type: String, default: 'collection-card card-social-header' },
        useCoverImage: {     type: Boolean, default: true },
        resolution: {        type: Object, default: () => { return {x: '50vw'}; }}
    },

    computed: {
        curatorName: function () {
            return this.getCuratorName(this.item);
        }
    },

    data: function () {
        return {
            resource: 'collections'
        };
    },

    methods: {
        getCardRoute: function (item) {
            return this.getRoute(
                item, null, 'Collection');
        }
    }
};
</script>

<style lang="scss">
// @import '~assets/styles/variables';

.collection-card {
    .curator {
        font-family: $helvetica-light;
    }
    .body-html {
        font-family: $helvetica-light;
        font-weight: normal;
        letter-spacing: 1px;
    }
}
</style>
